module.exports = __webpack_public_path__ + "static/media/ks_large_qpcr.a159ab1c.svg";